import { useState } from 'react';

export const SuperAdminModel = () => {
  const [formData, setFormData] = useState({
        ContractPrefix:'',
        Line1:'',
        Line2:'',
        Line3:'',
        CompanyName:'',
        Address1:'',
        Address2:'',
        Town:'',
        County:'',
        Postcode:'',
        Country:'',
        VATReg:'',
        Contact:'',
        Telephone:'',
        Fax:'',
        Email:'',
        StartDate:"",
        EndDate:"",
        LanuguageID:""
  });

  return [formData, setFormData];
};